/**
 * @ignore
 * Created by shanie on 3/8/17.
 */

import { useState } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';
import PropTypes from 'prop-types';

import LikeHeartIcon from 'dibs-icons/exports/LikeHeartIcon';
import { Link } from 'dibs-elements/exports/Link';

// Styles
import classnames from 'classnames';
import styles from './Heart-Styles.scss';

const messages = defineMessages({
    label: {
        id: 'dibs-portfolio-heart.HeartIconWrapper.label',
        defaultMessage: 'Save to favorites',
    },
});

const HeartIconWrapper = props => {
    const intl = useIntl();
    const [isActive, setIsActive] = useState(false);
    const className = classnames(styles.heart, props.className, {
        [styles[props.type]]: props.type,
    });
    const iconClasses = classnames(styles.icon, {
        [styles.isStrokeWidthHeavy]: props.isStrokeWidthHeavy,
        [styles.hoverClass]: props.useHoverClass,
        [styles.darkTheme]: props.darkTheme,
    });

    const dataTn = props.isFavorited ? 'item-saved-icon' : 'item-save-icon';
    const id = `${props.itemId}-heart`;

    function toggleActive(active) {
        if (props.type === 'button') {
            setIsActive(active);
        }
    }

    return (
        <Link
            ariaLabel={intl.formatMessage(messages.label)}
            className={classnames(
                styles.iconWrapper,
                {
                    [styles[props.type]]: props.type,
                    [styles.isActive]: isActive,
                },
                props.buttonClass
            )}
            onClick={props.onClick}
            onTouchStart={() => toggleActive(true)}
            onTouchEnd={() => toggleActive(false)}
            dataTn={dataTn}
            id={id}
        >
            <div className={className} onAnimationEnd={props.onAnimationEnd}>
                <LikeHeartIcon
                    className={iconClasses}
                    animateHeartBeat={props.isAnimated}
                    isFilled={props.isFilled}
                    darkTheme={props.darkTheme}
                />
            </div>
        </Link>
    );
};

HeartIconWrapper.defaultProps = {
    isFavorited: false,
    type: 'outline',
    isStrokeWidthHeavy: false,
    useHoverClass: false,
};

HeartIconWrapper.propTypes = {
    className: PropTypes.string,
    buttonClass: PropTypes.string,
    isStrokeWidthHeavy: PropTypes.bool,
    isAnimated: PropTypes.bool,
    isFavorited: PropTypes.bool,
    isFilled: PropTypes.bool,
    useHoverClass: PropTypes.bool,
    onClick: PropTypes.func,
    onAnimationEnd: PropTypes.func,
    type: PropTypes.oneOf(['outline', 'button']),
    itemId: PropTypes.string,
    darkTheme: PropTypes.bool,
};

export default HeartIconWrapper;
